var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnValue2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.267,
    height: 86.936,
    viewBox: "0 0 86.267 86.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-value2",
    transform: "translate(-707.367 -4152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2419",
    "data-name": "Groupe 2419",
    transform: "translate(707.367 4152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 86.267,
    height: 86.936,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2420",
    "data-name": "Groupe 2420",
    transform: "translate(663.787 4089.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2321",
    "data-name": "Trac\\xE9 2321",
    d: "M58,96.692c.222-1,.37-2.021.678-2.993a13.81,13.81,0,0,1,22.4-6.007c1.28,1.169,2.435,2.475,3.614,3.684-.53.557-1.081,1.167-1.665,1.742-1.439,1.416-2.895,2.814-4.341,4.223a6.843,6.843,0,1,0,9.556,9.8c.654-.641,1.306-1.285,1.94-1.945.247-.257.42-.281.686-.014q6.433,6.454,12.876,12.9a2.145,2.145,0,0,1-3.03,3.037c-1.263-1.221-2.48-2.49-3.735-3.72a1.91,1.91,0,1,0-2.662,2.732c1.165,1.162,2.344,2.309,3.484,3.5A2.428,2.428,0,0,1,96.64,127.7a2.377,2.377,0,0,1-2.361-.684c-1.161-1.165-2.32-2.333-3.493-3.486a1.814,1.814,0,0,0-1.959-.475,1.836,1.836,0,0,0-1.282,1.5,1.915,1.915,0,0,0,.638,1.767c1.152,1.148,2.321,2.279,3.443,3.456a2.433,2.433,0,0,1-1.19,4.1,2.264,2.264,0,0,1-2.183-.574q-1.925-1.881-3.8-3.809a.575.575,0,0,1-.12-.51,6.432,6.432,0,0,0-3.374-8.69.48.48,0,0,1-.1-.078c1.579-2.752,1.613-5.464-.533-7.91-1.911-2.179-4.367-2.636-7.143-1.734a6.42,6.42,0,0,0-4.684-4.349,6.3,6.3,0,0,0-6.134,1.8,12.867,12.867,0,0,1-3.41-5.076c-.383-1.083-.572-2.234-.849-3.354L58,99.159Z",
    transform: "translate(0 0)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2322",
    "data-name": "Trac\\xE9 2322",
    d: "M231.783,117.163a3.322,3.322,0,0,0-.378-.6q-5.284-5.3-10.582-10.591a4.014,4.014,0,0,0-6.126,0c-.61.606-1.21,1.222-1.827,1.821a3.038,3.038,0,0,1-4.326.034,2.989,2.989,0,0,1,.055-4.318c4.066-3.969,8.068-8.008,12.247-11.854A13.009,13.009,0,0,1,242.419,99a12.585,12.585,0,0,1-3.963,11.854c-2.005,1.932-4.043,3.831-6.067,5.744C232.242,116.741,232.092,116.877,231.783,117.163Z",
    transform: "translate(-127.227 -3.452)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2323",
    "data-name": "Trac\\xE9 2323",
    d: "M128.633,283.256a2.436,2.436,0,0,1,2.128,1.539,2.348,2.348,0,0,1-.456,2.754q-2.882,2.944-5.828,5.827a2.558,2.558,0,0,1-3.576-3.658c1.891-1.915,3.8-3.81,5.705-5.712A2.607,2.607,0,0,1,128.633,283.256Z",
    transform: "translate(-52.838 -169.3)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2324",
    "data-name": "Trac\\xE9 2324",
    d: "M78,261.766A2.393,2.393,0,0,1,78.72,260c1.185-1.193,2.363-2.393,3.569-3.565a2.56,2.56,0,0,1,3.68,3.546q-1.808,1.915-3.726,3.723a2.311,2.311,0,0,1-2.709.41A2.5,2.5,0,0,1,78,261.766Z",
    transform: "translate(-17.004 -145.896)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2325",
    "data-name": "Trac\\xE9 2325",
    d: "M170.445,350.325a2.4,2.4,0,0,1-.711,1.772c-.762.77-1.518,1.547-2.3,2.3a2.562,2.562,0,0,1-3.619-3.627c.763-.795,1.535-1.583,2.341-2.333a2.363,2.363,0,0,1,2.752-.449A2.481,2.481,0,0,1,170.445,350.325Z",
    transform: "translate(-89.326 -224.113)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnValue2);
export default __webpack_public_path__ + "static/media/icn-value2.6504c250f7e3314e68249e3e3a450bd5.svg";
export { ForwardRef as ReactComponent };